import BaseCarouselElement, { defineElement } from '@webtides/carousel-element';
import { classMap } from '@webtides/element-js/src/dom-parts/directives';
import { html } from '@webtides/element-js';

import style from './carousel-element.css';

class CarouselElement extends BaseCarouselElement {
    childrenLength = this.getUniqueChildren().length;

    styles() {
        return [style];
    }

    addEventListeners() {
        window.addEventListener('beforeprint', this.onPrint.bind(this));
        window.addEventListener('afterprint', this.afterPrint.bind(this));
    }
    onPrint() {
        super.destroyGlide();
    }
    afterPrint() {
        this.mountGlide();
    }

    connected() {
        super.connected();
        this.addEventListeners();
        this.querySelectorAll('[data-image]').forEach((image) => image.removeAttribute('cloak'));
    }

    mountGlide() {
        if (this.disabled || this.childrenLength <= 1) {
            return;
        }
        super.mountGlide();

        this.api.on('run', () => {
            this.$refs.fraction.textContent = this.currentIndex + 1;
        });
        const maxCaptionHeight = this.maxCaptionHeight;
        if (maxCaptionHeight > 0) {
            this.$refs.mobileNumbers.style.bottom = `${maxCaptionHeight + 12}px`;
            this.$refs.arrowsBlock.style.bottom = `${maxCaptionHeight - 35}px`;
        }
        this.hasImageCaption;
    }

    get maxCaptionHeight() {
        let maxCaptionHeight = 0;
        this.querySelectorAll('.caption').forEach((el) => {
            if (el.offsetHeight > maxCaptionHeight) {
                maxCaptionHeight = el.offsetHeight;
            }
        });
        return maxCaptionHeight;
    }

    get currentIndex() {
        return this.api?.index;
    }

    get hasImageCaption() {
        return this.querySelectorAll('.caption').length > 0;
    }

    renderBullets() {
        let bullets = [];
        for (let i = 0; i < this.childrenLength; i++) {
            bullets.push(` <div part="dot" class="glide__bullet" data-glide-dir="=${i}"></div> `);
        }
        return bullets.join('');
    }

    template() {
        const cssClasses = {
            absolute: this.hasImageCaption,
            relative: !this.hasImageCaption,
        };

        if (this.disabled || this.childrenLength <= 1) {
            return `
                <slot></slot>
            `;
        }

        return `
            <div class="glide" ref="glide">
                <div class="glide__track" data-glide-el="track" part="track">
                    <div class="glide__slides" part="slides">
                        ${this._options.shadowRender
                            ? `
                                  <slot></slot>
                              `
                            : this.renderSlides()}
                    </div>
                </div>
                <div ref="mobileNumbers" class="numbers lg:hidden">
                    <span ref="fraction">1</span>
                    / ${this.childrenLength}
                </div>
                <div
                    ref="arrowsBlock"
                    class="${classMap(cssClasses)} bottom-0 right-0 hidden flex-row-reverse gap-10 lg:flex">
                    ${this.arrows
                        ? html`
                              <div part="arrows" class="glide__arrows" data-glide-el="controls">
                                  <button
                                      part="arrow arrow-left"
                                      class="glide__arrow glide__arrow--left"
                                      data-glide-dir="<">
                                      <slot name="arrow-left"></slot>
                                  </button>
                                  <button
                                      part="arrow arrow-right"
                                      class="glide__arrow glide__arrow--right"
                                      data-glide-dir=">">
                                      <slot name="arrow-right"></slot>
                                  </button>
                              </div>
                          `
                        : ''}
                    ${this.bullets
                        ? `
                              <div part="dots" class="glide__bullets" data-glide-el="controls[nav]">
                                  ${this.renderBullets()}
                              </div>
                          `
                        : ''}
                </div>
            </div>
        `;
    }
}

export function define() {
    defineElement('carousel-element', CarouselElement);
}
